export enum RateMeetingSource {
  RATE_SCHEDULE_MEETING = 'rate-schedule-meeting',
  PEOPLE_CTA = 'people-cta',
}
